import { OrderedList as BaseOrderedList } from "@tiptap/extension-ordered-list";

export const OrderedList = BaseOrderedList.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      class: {
        default: "rich-text rich-text--number",
        renderHTML: () => ({ class: "rich-text rich-text--number" }),
      },
    };
  },
});
